import { type ReactNode, type TouchEvent } from "react";

type RemoteTouchpadProps = {
  borderActiveClass: string;
  hintIconClass: string;
  hintText: string;
  showHint: boolean;
  onTouchStart?: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchMove?: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: TouchEvent<HTMLDivElement>) => void;
  /** PDF 또는 미리보기 children — 기본적으로 inset-0, pointer-events-none 컨테이너에 들어감 */
  pdfSlot?: ReactNode;
  /** 위에 떠 있는 visualizer (laser dot, highlight overlay, magnifier lens 등) */
  children?: ReactNode;
};

export default function RemoteTouchpad({
  borderActiveClass,
  hintIconClass,
  hintText,
  showHint,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  pdfSlot,
  children,
}: RemoteTouchpadProps) {
  return (
    <div
      className={`relative w-full aspect-video bg-black rounded-2xl border-2 border-slate-300 overflow-hidden transition-all touch-none ${borderActiveClass}`}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {pdfSlot && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {pdfSlot}
        </div>
      )}
      {showHint && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/20 pointer-events-none z-20">
          <div className="rounded-full bg-white/30 flex items-center justify-center backdrop-blur-sm w-8 h-8">
            <i className={`${hintIconClass} text-white text-lg`}></i>
          </div>
          <p className="mt-2 text-xs font-medium text-white/80">
            {hintText}
          </p>
        </div>
      )}
      {children}
    </div>
  );
}
